<p>
  integration-edit works!
</p>
<div class="p-col-12 p-d-flex">
  <div class="flex-grow-1"></div>
  <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary  p-button-text" (click)="cancel()">
  </p-button>
  <button class="p-ml-2" style="float: right;" icon="pi pi-save" pButton type="button" label="Guardar" (click)="save()"></button>
</div>